import { render, staticRenderFns } from "./CustomDealForm.vue?vue&type=template&id=24b781f9&"
import script from "./CustomDealForm.vue?vue&type=script&lang=js&"
export * from "./CustomDealForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports